import _get from 'lodash/get';
import ValidityHint from '@lib/enums/validityHint';
import { TaskCompletionDetailsTableRow } from '../types';
import styles from '../TaskCompletionDetails.module.scss';

export default function getTableRowClassNameByValidityHint(
  item: TaskCompletionDetailsTableRow,
) {
  const validityHint = _get(item, ['answer', 'validityHint']) as string;
  if (validityHint === ValidityHint.Failure) {
    return styles.redRow;
  }
  if (validityHint === ValidityHint.Warning) {
    return styles.yellowRow;
  }
  return undefined;
}
